import React from 'react';
import MaterialLayout from './components/Layout/MaterialLayout';
// import EmploymentPage from './components/EmploymentPage';
import EmploymentPage from './components/EmploymentPage/EmploymentPageTest2';

function Stepper4() {
  //https://medium.com/@nphivu414/build-a-multi-step-form-with-react-hooks-formik-yup-and-materialui-fa4f73545598
  return (
    <div>
      <MaterialLayout>
        <EmploymentPage />
      </MaterialLayout>
    </div>
  );
}

export default Stepper4;
